<template>
  <div class="main-rating-content">
    <span
      v-show="!tags_loaded"
      class="el-icon-loading"/>

    <div
      v-button-event="{buttonText: 'thumps-up', contentType: 'podcast', contentData: {uuid: podcast_id}}"
      v-if="show_like"
      v-show="tags_loaded"
      :class="isThumbsUpRatingSet ? 'b-0' : ''"
      class="like"
      data-test="thumbsup"
      @click="clickRating(thumbs_up_code)">
      <img
        v-if="isThumbsUpRatingSet"
        src="../assets/images/ic_thumbs_up_white_filled.svg">
      <svg v-else="" class="svg-with-hover" svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_thumbs_up_white_svg__a" d="M4.39675497,19.1496391 C5.07742594,19.134184 5.62645289,19.2129329 6.16512081,19.4562328 C7.90259886,20.2409986 10.6568225,20.550608 12.3068428,20.3856254 C13.1151968,20.3047994 14.1225389,20.1349798 14.9206774,19.9212866 C15.387504,19.7962986 15.7674849,19.6608565 16.0282381,19.526029 C16.1876876,19.4435825 16.2362531,19.3995781 16.2077994,19.4929469 C16.2705139,19.2871542 16.2530699,19.2011218 16.1524842,19.0924657 C15.6692692,18.5704804 15.8701524,17.7251162 16.5365305,17.4763079 C16.7584704,17.3934413 16.9069913,17.2103617 17.0091281,16.8172213 C17.0995973,16.4689914 17.0681805,16.332623 16.9559169,16.2353075 C16.3673893,15.7251437 16.562225,14.767746 17.3033288,14.5281694 C17.6071439,14.4299551 17.7324775,14.2735109 17.778817,13.9064702 C17.8232463,13.5545606 17.7410623,13.3419435 17.4966716,13.1431979 C16.9729834,12.7173194 17.0129737,11.9056042 17.5759873,11.5332637 C17.9356417,11.2954117 18.0339548,11.0631527 17.9165932,10.6268284 C17.8196612,10.5309496 17.5771914,10.4296633 17.0005766,10.2847908 C16.8713233,10.2523164 16.0826932,10.0660283 15.8222719,10.0002407 C15.6075884,9.94600728 14.1783164,9.95965627 11.8822997,10.069969 C11.2836574,10.098731 10.7943406,9.59805957 10.8368254,9.00023441 C10.9594878,7.27418865 10.9045384,5.61803654 10.6727746,4.03076379 C10.5415223,3.13186006 10.4203136,2.55071302 10.304815,2.21258269 C10.2322502,2.00014383 10.2655903,2.0393887 10.189724,1.99665409 C10.1594899,1.97971885 10.1594899,1.97971885 10.1195373,1.95725838 C10.1945178,1.99968945 10.0704188,2.00033917 9.91323783,2.04639469 C9.70809519,2.10650343 9.5513602,2.20586493 9.51746614,2.25815862 C9.46890484,2.33308177 9.12469062,3.75349397 8.64588715,5.94953572 C8.62697383,6.03630374 8.62697383,6.03630374 8.60806017,6.12314674 C8.16586192,8.15387238 8.13088899,8.31302652 7.98387199,8.94507363 C7.69062097,10.2058016 7.60645752,10.5095894 7.36784493,10.7861882 C7.11273601,11.0819142 6.80736531,11.3276449 6.37309419,11.6218792 C6.28070596,11.6844756 5.90792068,11.9296874 5.82511873,11.9864881 C5.68670718,12.0814361 5.6039665,12.1465917 5.57661918,12.1757004 C5.36717132,12.3987753 6.0942558,12.1448493 2.08224666,13.557096 L2.70912972,19.1589507 C3.42992574,19.1618941 3.99301951,19.1587674 4.39675497,19.1496391 Z M18.1209347,20.0759674 C17.6964774,21.4687903 15.3840793,22.0879106 12.5058271,22.3757021 C10.5328564,22.572976 7.43616699,22.2248691 5.34186172,21.2789353 C5.11965934,21.1785733 4.8498093,21.1398677 4.44205858,21.149126 C3.85982532,21.16229 2.98226542,21.1634942 1.80513738,21.1529163 C1.29933796,21.148371 0.876579883,20.7668509 0.820326571,20.2641688 L0.00620331193,12.9891275 C-0.0455721283,12.5264599 0.228782462,12.0892674 0.667918029,11.9346648 C1.93330327,11.4891717 2.88564708,11.1512179 3.52411724,10.9211082 C3.84067617,10.8070179 4.07909373,10.7197893 4.23785374,10.6600117 C4.4060901,10.541856 4.5351806,10.4460204 4.69376043,10.3372373 C4.79657581,10.2667077 5.17588599,10.0172038 5.25126548,9.96613153 C5.48015835,9.81104836 5.64509821,9.68519936 5.76034487,9.57633195 C5.77355131,9.5335152 5.78880995,9.48109768 5.80571534,9.42007768 C5.86594488,9.20267928 5.94242604,8.89371506 6.03587586,8.49196094 C6.17964756,7.8738659 6.21492491,7.71332641 6.65385461,5.69761103 C6.67281756,5.61054171 6.67281756,5.61054171 6.69179395,5.52348434 C7.34973373,2.50583032 7.57435439,1.5789252 7.83916017,1.17036771 C8.48000396,0.181637294 10.1684496,-0.313093365 11.1045449,0.216637798 C11.1338146,0.233088079 11.1338146,0.233088079 11.1712898,0.254090293 C11.6686712,0.534259402 11.9635598,0.881374876 12.1974473,1.56609751 C12.3611985,2.04549111 12.504257,2.73139924 12.6517896,3.74180025 C12.8538649,5.12574684 12.9326373,6.55302316 12.8885132,8.02311221 C14.8104973,7.945347 15.8806003,7.95214556 16.3121234,8.06115697 C16.5529357,8.121991 17.3398882,8.3078828 17.4879233,8.34507609 C18.6698687,8.64203584 19.2894381,8.95595533 19.7053228,9.70898178 L19.7801202,9.88069554 C20.0990644,10.8528228 19.9909341,11.7431611 19.4774762,12.4518684 C19.7442809,12.9526448 19.842163,13.5304805 19.7630656,14.1569853 C19.6769484,14.8390912 19.4046151,15.4050677 18.9682736,15.8209031 C19.0944319,16.2740248 19.0847097,16.7818515 18.9448687,17.3201214 C18.7953202,17.8957565 18.5373401,18.3777098 18.1762306,18.7444362 C18.2801433,19.1625192 18.2618615,19.6135276 18.1209347,20.0759674 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-170.000000, -296.000000) translate(170.000000, 296.000000) translate(2.000000, 1.000000)"><mask id="ic_thumbs_up_white_svg__b" fill="white"><use xlink:href="#ic_thumbs_up_white_svg__a"/></mask><g fill="#FFFFFF" mask="url(#ic_thumbs_up_white_svg__b)"><g transform="translate(-2.000000, -1.000000)"><rect width="24" height="24"/></g></g></g></g></g></g></svg>
    </div>

    <div
      v-button-event="{buttonText: 'thumps-down', buttonLink: null}"
      v-if="show_dislike"
      v-show="tags_loaded"
      :class="isThumbsDownRatingSet ? 'b-0' : ''"
      class="dislike"
      data-test="thumbsdown"
      @click="clickRating(thumbs_down_code)">
      <img
        v-if="isThumbsDownRatingSet"
        src="../assets/images/ic_thumbs_down_white_filled.svg">
      <svg v-else="" class="svg-with-hover" svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_thumbs_down_white_svg__a" d="M4.39675497,19.1496391 C5.07742594,19.134184 5.62645289,19.2129329 6.16512081,19.4562328 C7.90259886,20.2409986 10.6568225,20.550608 12.3068428,20.3856254 C13.1151968,20.3047994 14.1225389,20.1349798 14.9206774,19.9212866 C15.387504,19.7962986 15.7674849,19.6608565 16.0282381,19.526029 C16.1876876,19.4435825 16.2362531,19.3995781 16.2077994,19.4929469 C16.2705139,19.2871542 16.2530699,19.2011218 16.1524842,19.0924657 C15.6692692,18.5704804 15.8701524,17.7251162 16.5365305,17.4763079 C16.7584704,17.3934413 16.9069913,17.2103617 17.0091281,16.8172213 C17.0995973,16.4689914 17.0681805,16.332623 16.9559169,16.2353075 C16.3673893,15.7251437 16.562225,14.767746 17.3033288,14.5281694 C17.6071439,14.4299551 17.7324775,14.2735109 17.778817,13.9064702 C17.8232463,13.5545606 17.7410623,13.3419435 17.4966716,13.1431979 C16.9729834,12.7173194 17.0129737,11.9056042 17.5759873,11.5332637 C17.9356417,11.2954117 18.0339548,11.0631527 17.9165932,10.6268284 C17.8196612,10.5309496 17.5771914,10.4296633 17.0005766,10.2847908 C16.8713233,10.2523164 16.0826932,10.0660283 15.8222719,10.0002407 C15.6075884,9.94600728 14.1783164,9.95965627 11.8822997,10.069969 C11.2836574,10.098731 10.7943406,9.59805957 10.8368254,9.00023441 C10.9594878,7.27418865 10.9045384,5.61803654 10.6727746,4.03076379 C10.5415223,3.13186006 10.4203136,2.55071302 10.304815,2.21258269 C10.2322502,2.00014383 10.2655903,2.0393887 10.189724,1.99665409 C10.1594899,1.97971885 10.1594899,1.97971885 10.1195373,1.95725838 C10.1945178,1.99968945 10.0704188,2.00033917 9.91323783,2.04639469 C9.70809519,2.10650343 9.5513602,2.20586493 9.51746614,2.25815862 C9.46890484,2.33308177 9.12469062,3.75349397 8.64588715,5.94953572 C8.62697383,6.03630374 8.62697383,6.03630374 8.60806017,6.12314674 C8.16586192,8.15387238 8.13088899,8.31302652 7.98387199,8.94507363 C7.69062097,10.2058016 7.60645752,10.5095894 7.36784493,10.7861882 C7.11273601,11.0819142 6.80736531,11.3276449 6.37309419,11.6218792 C6.28070596,11.6844756 5.90792068,11.9296874 5.82511873,11.9864881 C5.68670718,12.0814361 5.6039665,12.1465917 5.57661918,12.1757004 C5.36717132,12.3987753 6.0942558,12.1448493 2.08224666,13.557096 L2.70912972,19.1589507 C3.42992574,19.1618941 3.99301951,19.1587674 4.39675497,19.1496391 Z M18.1209347,20.0759674 C17.6964774,21.4687903 15.3840793,22.0879106 12.5058271,22.3757021 C10.5328564,22.572976 7.43616699,22.2248691 5.34186172,21.2789353 C5.11965934,21.1785733 4.8498093,21.1398677 4.44205858,21.149126 C3.85982532,21.16229 2.98226542,21.1634942 1.80513738,21.1529163 C1.29933796,21.148371 0.876579883,20.7668509 0.820326571,20.2641688 L0.00620331193,12.9891275 C-0.0455721283,12.5264599 0.228782462,12.0892674 0.667918029,11.9346648 C1.93330327,11.4891717 2.88564708,11.1512179 3.52411724,10.9211082 C3.84067617,10.8070179 4.07909373,10.7197893 4.23785374,10.6600117 C4.4060901,10.541856 4.5351806,10.4460204 4.69376043,10.3372373 C4.79657581,10.2667077 5.17588599,10.0172038 5.25126548,9.96613153 C5.48015835,9.81104836 5.64509821,9.68519936 5.76034487,9.57633195 C5.77355131,9.5335152 5.78880995,9.48109768 5.80571534,9.42007768 C5.86594488,9.20267928 5.94242604,8.89371506 6.03587586,8.49196094 C6.17964756,7.8738659 6.21492491,7.71332641 6.65385461,5.69761103 C6.67281756,5.61054171 6.67281756,5.61054171 6.69179395,5.52348434 C7.34973373,2.50583032 7.57435439,1.5789252 7.83916017,1.17036771 C8.48000396,0.181637294 10.1684496,-0.313093365 11.1045449,0.216637798 C11.1338146,0.233088079 11.1338146,0.233088079 11.1712898,0.254090293 C11.6686712,0.534259402 11.9635598,0.881374876 12.1974473,1.56609751 C12.3611985,2.04549111 12.504257,2.73139924 12.6517896,3.74180025 C12.8538649,5.12574684 12.9326373,6.55302316 12.8885132,8.02311221 C14.8104973,7.945347 15.8806003,7.95214556 16.3121234,8.06115697 C16.5529357,8.121991 17.3398882,8.3078828 17.4879233,8.34507609 C18.6698687,8.64203584 19.2894381,8.95595533 19.7053228,9.70898178 L19.7801202,9.88069554 C20.0990644,10.8528228 19.9909341,11.7431611 19.4774762,12.4518684 C19.7442809,12.9526448 19.842163,13.5304805 19.7630656,14.1569853 C19.6769484,14.8390912 19.4046151,15.4050677 18.9682736,15.8209031 C19.0944319,16.2740248 19.0847097,16.7818515 18.9448687,17.3201214 C18.7953202,17.8957565 18.5373401,18.3777098 18.1762306,18.7444362 C18.2801433,19.1625192 18.2618615,19.6135276 18.1209347,20.0759674 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-187.000000, -381.000000) translate(199.000000, 393.000000) scale(1, -1) translate(-199.000000, -393.000000) translate(187.000000, 381.000000) translate(2.000000, 1.000000)"><mask id="ic_thumbs_down_white_svg__b" fill="white"><use xlink:href="#ic_thumbs_down_white_svg__a"/></mask><g fill="#FFFFFF" mask="url(#ic_thumbs_down_white_svg__b)"><g transform="translate(-2.000000, -1.000000)"><rect width="24" height="24"/></g></g></g></g></g></g></svg>
    </div>

    <el-dialog
      :visible.sync="show_rating_modal"
      :close="true"
      :append-to-body="true"
      :lock-scroll="true"
      class="rating-modal-wrapper"
      custom-class="rating-modal"
    >
      <div
        v-show="show_thumbs_up"
        data-test="popup-thumbsup">
        <loader
          v-show="!tags_loaded"
          :with-margin="true"
          label="Fetching Tags"/>
        <div
          v-show="tags_loaded"
          class="content">
          <h4>Thanks for rating!</h4>
          <p>Can you tell us more about what you liked?</p>
          <button
            v-button-event="{buttonText: item.title, buttonLink: null}"
            v-for="(item,index) in thumbs_up_tags"
            :class="item.selected ? 'btn-dark' : 'btn-transparent'"
            :key="index"
            data-test="rating-thumbsup"
            class="el-button"
            @click="selectTags(item,index,thumbs_up_code)">
            {{ item.title }}
          </button>
          <br>
          <el-button
            v-button-event="{buttonText: 'Submit Feeback', buttonLink: null}"
            :loading="submitting"
            :disabled="!isThumbsUpSelected"
            type="primary"
            class="submit bg-primary"
            @click.native="saveRating(thumbs_up_code)">
            Submit
          </el-button>
        </div>
      </div>
      <div
        v-show="show_thumbs_down"
        data-test="popup-thumbsdown">
        <div
          v-show="!report_content"
          class="tags">
          <loader
            v-show="!tags_loaded"
            label="Fetching Tags"/>
          <div
            class="content">
            <h4>Thanks for rating!</h4>
            <p>Can you tell us more about what you didn't like?</p>
            <button
              v-button-event="{buttonText: item.title, buttonLink: null}"
              v-for="(item,index) in thumbs_down_tags"
              :class="item.selected ? 'btn-dark' : 'btn-transparent'"
              :key="index"
              data-test="rating-thumbsdown"
              class="el-button"
              @click="selectTags(item,index,thumbs_down_code)">
              {{ item.title }}
            </button>
            <br>
            <el-button
              :loading="submitting"
              :disabled="!isThumbsDownSelected"
              type="primary"
              class="submit"
              @click.native="saveRating(thumbs_down_code)">Submit</el-button>
          </div>
          <p
            v-if="tags_loaded"
            v-show="!report_content"
            class="link"
            @click="report_content = true">Report this content</p>
        </div>
        <div
          v-show="tags_loaded && report_content"
          class="feedback">
          <div
            class="report">
            <h4>Report this content</h4>
            <p>Please tell us why you are reporting this content</p>
            <p>Your feedback..</p>
            <el-input
              :rows="3"
              v-model="feedback"
              type="textarea"
              placeholder="Please input"/>
            <el-button
              v-button-event="{buttonText: 'Submit Feeback', buttonLink: null}"
              :loading="submitting"
              type="primary"
              class="submit"
              @click="saveFeedback">
              Submit
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <login-modal
      v-if="show_login"
      :show_modal="show_login"
      @modalClosed="show_login = false"/>
  </div>
</template>
<script>
import * as log from 'loglevel';
import PodcastService from '../services/Podcast';
import EpisodeService from '../services/Episode';

export default {
  name: 'Rating',
  components: {
    Loader: () => import('./Loader'),
    Login: () => import('../pages/onboarding/SignIn'),
    LoginModal: () => import('./LoginModal'),
    VueContentLoading: () => import('vue-content-loading'),
  },
  props: {
    podcast_id: {
      type: String,
      default: '',
    },
    show_like: {
      type: Boolean,
      default: false,
    },
    show_dislike: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      podcast_service: new PodcastService(),
      episode_service: new EpisodeService(),
      thumbs_up_tags: [],
      thumbs_down_tags: [],
      received_rating: [],
      thumbs_up_code: 'thumbs_up',
      thumbs_down_code: 'thumbs_down',
      positive_rating: null,
      show_thumbs_up: false,
      show_thumbs_down: false,
      tags_loaded: true,
      submitting: false,
      report_content: false,
      show_login: false,
      feedback: '',
      show_rating_modal: false,
      is_safari_and_mobile: false,
    };
  },
  computed: {
    isThumbsUpSelected() {
      return this.thumbs_up_tags.filter(item => item.selected).length;
    },
    isThumbsDownSelected() {
      return this.thumbs_down_tags.filter(item => item.selected).length;
    },
    isThumbsUpRatingSet() {
      return this.positive_rating === this.thumbs_up_code;
    },
    isThumbsDownRatingSet() {
      return this.positive_rating === this.thumbs_down_code;
    },
    isFeedbackEmpty() {
      return this.feedback.length < 10;
    },
    isLoggedIn() {
      return this.$store.getters.loggedIn;
    },
    overlayShown() {
      return (this.show_thumbs_up || this.show_thumbs_down) && !this.isSafariMobile;
    },
  },
  watch: {
    show_rating_modal() {
      if (!this.show_rating_modal) this.report_content = false;
    },
  },
  mounted() {
    this.getRatings();
    this.getFeedback();
  },
  methods: {
    clickRating(type) {
      if (!this.isLoggedIn) {
        this.show_login = true;
        return;
      }
      this.show_thumbs_up = type === this.thumbs_up_code;
      this.show_thumbs_down = type === this.thumbs_down_code;
      this.show_rating_modal = true; // this.isSafariMobile;
    },
    getRatings() {
      this.podcast_service.getRatings()
        .then((res) => {
          this.thumbs_up_tags = res.thumbs_up.rating_answers.map(item => ({
            ...item,
            selected: false,
          }));
          this.thumbs_down_tags = res.thumbs_down.rating_answers.map(item => ({
            ...item,
            selected: false,
          }));
          this.tags_loaded = true;
          this.getSavedRating();
        })
        .catch((err) => {
          log.info(`Error fetching rating tags: ${err.message}`);
          this.showErrorMsg('Failed to fetch ratings.');
        });
    },
    removeOverlay() {
      this.show_thumbs_up = false;
      this.show_thumbs_down = false;
      this.report_content = false;
    },
    selectTags(item, index, type) {
      if (type === this.thumbs_up_code) {
        (this.thumbs_up_tags[index].selected = !this.thumbs_up_tags[index].selected);
      } else if (type === this.thumbs_down_code) {
        (this.thumbs_down_tags[index].selected = !this.thumbs_down_tags[index].selected);
      } else {
        log.warn('Invalid Type in selectTagsFunction');
      }
    },
    filterSelectedTags(type) {
      if (type === this.thumbs_up_code) {
        return this.thumbs_up_tags.filter(item => item.selected).map(item => ({
          code: item.code,
          title: item.title,
        }));
      }
      if (type === this.thumbs_down_code) {
        return this.thumbs_down_tags.filter(item => item.selected).map(item => ({
          code: item.code,
          title: item.title,
        }));
      }
      log.warn('Invalid Type Code in filterSelectedTags Function');
      return null;
    },
    clearTags(type) {
      if (type === this.thumbs_up_code) {
        this.thumbs_down_tags.forEach((item) => { item.selected = false; });
      } else if (type === this.thumbs_down_code) {
        this.thumbs_up_tags.forEach((item) => { item.selected = false; });
      } else {
        log.warn('Invalid code in clearTags');
      }
    },
    getSavedRating() {
      if (!this.isLoggedIn) {
        return;
      }
      const vm = this;
      this.podcast_service.getPodcastRating(this.podcast_id)
        .then((res) => {
          if (!Object.keys(res).length) return;
          const code = res.ratings && res.ratings.code;
          this.received_rating = res.ratings.rating_answers;
          if (!code || !this.received_rating) return;
          if (code === this.thumbs_up_code) {
            res.ratings.rating_answers.forEach((item) => {
              const index = vm.thumbs_up_tags.findIndex(elem => item.code === elem.code);
              if (index !== -1) {
                vm.thumbs_up_tags[index].selected = true;
                this.positive_rating = this.thumbs_up_code;
              }
            });
          } else if (code === this.thumbs_down_code) {
            res.ratings.rating_answers.forEach((item) => {
              const index = vm.thumbs_down_tags.findIndex(elem => item.code === elem.code);
              if (index !== -1) {
                vm.thumbs_down_tags[index].selected = true;
                this.positive_rating = this.thumbs_down_code;
              }
            });
          }
          this.tags_loaded = true;
        })
        .catch((error) => {
          log.warn(error.message);
          this.tags_loaded = true;
        });
    },
    saveRating(type) {
      this.submitting = true;
      const tags = this.filterSelectedTags(type);
      this.clearTags(type);
      this.podcast_service.updatePodcastRatings(this.podcast_id, type, tags)
        .then((res) => {
          this.removeOverlay();
          if (res.success) {
            this.triggerRatingEvent(type);
            this.positive_rating = type;
            this.showSuccessMsg('Ratings Saved!');
          } else {
            this.showErrorMsg('Your ratings were not saved!');
          }
          this.submitting = false;
          this.show_rating_modal = false;
        })
        .catch((error) => {
          this.submitting = false;
          this.showErrorMsg(error.message);
          log.warn(error.message);
        });
    },
    saveFeedback() {
      if (this.isNullOrWhiteSpace(this.feedback)) {
        this.showErrorMsg('Feedback can\'t be empty!');
        return;
      }
      this.submitting = true;
      if (this.type === 'show') {
        this.podcast_service
          .savePodcastFeedback(this.podcast_id, this.feedback)
          .then((res) => {
            this.submitting = false;
            this.removeOverlay();
            this.positive_rating = this.thumbs_down_code;
            if (res.success) {
              this.showSuccessMsg('Feedback Saved!');
            } else {
              this.showErrorMsg('Couldn\'t save your feedback. Please try again!');
            }
          })
          .catch((error) => {
            log.warn(error.message);
          })
          .then(() => {
            this.show_rating_modal = false;
          });
      }
    },
    getFeedback() {
      if (!this.isLoggedIn) {
        return;
      }
      if (this.type === 'show') {
        this.podcast_service.getPodcastFeedback(this.podcast_id)
          .then((res) => {
            this.feedback = res.content;
            if (res.content) {
              this.positive_rating = this.thumbs_down_code;
            }
          })
          .catch((error) => {
            log.warn(error.message);
          });
      } else {
        log.warn('Wrong Type code in getFeedback Function');
      }
    },
    showNotification() {
      this.showErrorMsg('You need to be logged in to perform this action.');
    },
    triggerRatingEvent(type) {
      const data = { show_uuid: this.podcast_id };
      if (type === this.thumbs_up_code) {
        data.show_like = true;
        data.show_dislike = false;
      } else {
        data.show_like = false;
        data.show_dislike = true;
      }
      this.$analytics.track('show_rating', data);
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";

.main-rating-content {
  @media (max-width: 567px) {
    display: flex;
  }
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  transition: .2s all ease-in-out;
  z-index: 999; // Keep it smaller than the size of Rating modal
}
.like,
.dislike {
  width: 40px;
  height: 40px;
  border: 0px solid $gray;
  box-sizing: border-box;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  cursor: pointer;
  svg {
    width: 24px;
    height: 24px;
  }
  .svg-with-hover:hover {
    path,
    rect {
      fill: $blue;
    }
  }
}
.bg-primary {
  border: none !important;
}
.thumbs-up,
.thumbs-down {
  background-color: #fff;
  position: fixed;
  height: 410px;
  width: 50%;
  max-width: 712px;
  z-index: 9992;
  text-align: center;
  bottom: 0px;
  top: 50%;
  left: 50%;
  transform: translate(-50%,100%);
  border-radius: 6px;
  transition: 0.3s all ease-in-out;
  .el-button[disabled] {
    height: 48px;
    width: 126px;
    background-color: #AFE7F1;
    border-color: transparent;
  }
  .link {
    text-decoration: underline;
    color: $black;
    // margin-top: 25px;
    cursor: pointer;
  }
  .el-icon-close {
    position: absolute;
    right: 20px;
    cursor: pointer;
    top: 20px;
    font-size: 24px !important;
    font-weight: bolder;
    z-index: 10000;
  }
  .content {
    .btn-transparent,
    .btn-dark {
      margin: 0px 8px 8px 0 !important;
      padding: 9px 15px !important;
      font-size: 14px;
    }
    .btn-dark {
      color: $black !important;
      background-color: $peach !important;
    }
    .btn-dark:hover {
      background-color: $peach !important;
      color: $black !important;
    }
    .btn-transparent:hover {
      background-color: #fff !important;
      color: $black !important;
      border: 1px solid $black;
    }
    h4 {
      font-weight: 400;
      margin: 64px 0 8px 0;
      font-size: 24px;
      color: $black;
    }
    p {
      color: $black;
      font-size: 16px;
      margin-bottom: 24px;
    }
    .submit {
      // margin-top : 40px;
      margin-top : 15px;
      height: 48px;
      width: 126px;
    }
  }
  .report {
    width: 60%;
    margin: auto;
    h4 {
      font-weight: 400;
      margin-bottom: 0.8rem;
      font-size: 24px;
      color: $black;
    }
    p {
      color: $gray;
      font-size: 16px;
      color: $gray;
    }
    p:nth-child(3) {
      margin-top: 20px;
      color: $black;
    }
    .el-button--info {
      margin-top: 40px;
      width: 112px;
    }
    .el-textarea {
      width: 100%;
      textarea {
        border: 1px solid $light-gray2 !important;
        border-radius: 7px;
        resize: none;
      }
    }
    .submit {
      margin-top: 15px !important;
      width: 112px;
      padding: 15px !important;
    }
  }
}
.translateY0{
  transform: translate(-50%,-50%);
  transition: 0.4 s all ease-in-out;
}
.translateY100{
  transform: translate(-50%,100%);
  transition: 0.4 s all ease-in-out;
}
@media(max-width: $md) {
  .thumbs-up, .thumbs-down {
    width:60% !important;
  }
}
@media(max-width: $sm) {
  .thumbs-up, .thumbs-down {
    width:80% !important;
    padding-bottom:50px;
    .report {
      width:80% !important;
    }
  }
}
@media(max-width: $xxs) {
  .thumbs-up, .thumbs-down {
    width:90% !important;
    left:50%;
    .report {
      width:90% !important;
    }
  }
}

.rating-modal-wrapper {
  display: flex;
  align-items: center;
  .el-dialog.rating-modal {
    width: 95%;
    max-width: 713px;
    border-radius: 6px;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    @media (max-width: 1024px) {
      max-width: 587px;
    }
    @media (max-width: 768px) {
      max-width: 507px;
    }
  }
}
</style>
